import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../network/API";
import { DeleteTimesheetRequest, GetManagerEmployees, IRejectWithValue, ManagerTimesheetEmployee, PhpResponse } from "../../../types";
import { axiosClient, phpClient } from "../../../network";

export const getAllTimesheets = createAsyncThunk(
    "/timesheets/all",
    async (
        {
            employee_id = "",
            pay_period,
            record_type = "A",
            sort_by = "os_emp_start_datetime",
            sort_order = "DESC",
            page = "1",
        }: {
            pay_period: string;
            employee_id: string;
            record_type?: string;
            sort_by?: string;
            sort_order?: string;
            page?: string;
        },
        thunkAPI
    ) => {
        const { rejectWithValue } = thunkAPI;

        try {
            const data = { employee_id, pay_period, record_type, sort_by, sort_order, page };
            const response = await API.post("/timecard/timesheets", data);

            // const response = await API.get("/pay-period/all", {});
            return response.data;
        } catch (error) {
            console.error("*** getAllTimesheets API error", error);
            return rejectWithValue(error);
        }
    }
);

export const getSummary = createAsyncThunk(
    "timesheet/summary",
    async (
        data: {
            employee_id: string;
            pay_period: string;
        },
        thunkAPI
    ) => {
        const { rejectWithValue } = thunkAPI;

        try {
            const response = await API.post("/timecard/employee_hours_summary", data);
            return response.data;
        } catch (error) {
            console.error("*** getSummary API error", error);
            return rejectWithValue(error);
        }
    }
);

export const getManagerEmployees = createAsyncThunk<ManagerTimesheetEmployee[], GetManagerEmployees, IRejectWithValue>(
    "timesheet/manager/employees",
    async (data, thunkAPI) => {
        const { rejectWithValue } = thunkAPI;

        try {
            // Backend issue: When employee_id is an empty string, it gets converted to "-1"
            // To work around this, we omit the employee_id property entirely when it's empty
            // This ensures we don't filter by employee ID as required
            
            const response = await phpClient.post<PhpResponse<ManagerTimesheetEmployee[]>>({
                url: "/timecard/manager_timesheet_summary",
                data,
            });
            return response.data ?? [];
        } catch (error) {
            console.error("*** getManagerEmployees API error", error);
            return rejectWithValue(error as any);
        }
    }
);

export const deleteTimesheet = createAsyncThunk<void, DeleteTimesheetRequest, IRejectWithValue>(
    "timesheet/delete",
    async (data, thunkAPI) => {
        const { rejectWithValue } = thunkAPI;
        const {record_id} = data;
        try {
            const response = await phpClient.get<PhpResponse<void>>({
                url: `/timecard/delete/${record_id}`,
            });
            return response.data;
        } catch (error) {
            console.error("*** deleteTimesheet API error", error);
            return rejectWithValue(error as any);
        }
    }
);
